<template>
    <floating-menu :visible="shouldShow" :position="{top: '120px'}">
        <ul>
            <li>
                <assign-button
                    :assigned-users="[]"
                    :available-users="$store.getters['inbox/messageBoxes/users']"
                    :conversations="selected"
                    @changed="conversationsChanged"
                />
            </li>
            <li>
                <status-button
                    :conversations="selected"
                    @changed="conversationsChanged"
                />
            </li>
            <li>
                <tag-button
                    :conversations="selected"
                    @changed="conversationsChanged"
                />
            </li>
            <li>
                <message-box-button
                    :conversations="selected"
                    @changed="conversationsChanged"
                />
            </li>
        </ul>
    </floating-menu>
</template>

<script>
    import AssignButton from "./AssignButton"
    import StatusButton from './StatusButton'
    import MessageBoxButton from "./MessageBoxButton";
    import TagButton from "./TagButton";
    import FloatingMenu from "../elements/FloatingMenu";

    export default {
        components: {FloatingMenu, TagButton, AssignButton, StatusButton, MessageBoxButton },
        props: {
            selected: {
                type: Array,
                required: true
            }
        },
        computed: {
            shouldShow() {
                return this.selected.length > 0
            },
        },
        methods: {
            conversationsChanged() {
                this.$emit('changed')
                this.$store.dispatch('user/badges/update')
            }
        }
    }
</script>